import { useState } from "react";
import axios, { API } from "../../api";

/** "Forgot password" — user enters email; we send a reset link. */
export function ForgotPasswordScreen({ onBack }) {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e?.preventDefault();
    setError("");
    if (!email.trim()) return;
    setSubmitting(true);
    try {
      await axios.post(`${API}/auth/forgot-password`, { email: email.trim() });
      setSent(true);
    } catch (err) {
      setError(err?.response?.data?.detail || "Could not send reset email");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="app-container">
      <div className="init-screen">
        <div className="init-content auth-form" data-testid="forgot-password-screen">
          {!sent ? (
            <>
              <h2 className="auth-title">Forgot your password?</h2>
              <p style={{ opacity: 0.75, marginBottom: "1rem" }}>
                Enter the email you signed up with. We'll send you a reset link.
              </p>
              <form onSubmit={submit}>
                <input
                  type="email"
                  className="init-input"
                  placeholder="Your email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  data-testid="forgot-email-input"
                  autoFocus
                />
                {error && <div className="error-message" data-testid="forgot-error">{error}</div>}
                <button
                  type="submit"
                  className="init-btn"
                  disabled={submitting || !email.trim()}
                  data-testid="forgot-submit-btn"
                >
                  {submitting ? "Sending..." : "Send reset link"}
                </button>
              </form>
              <button className="ghost-btn small" onClick={onBack} data-testid="forgot-back-btn">
                ← Back to login
              </button>
            </>
          ) : (
            <>
              <div style={{ fontSize: "3rem", textAlign: "center" }}>📬</div>
              <h2 className="auth-title">Check your email</h2>
              <p style={{ opacity: 0.85 }} data-testid="forgot-sent-msg">
                If <strong>{email}</strong> exists in our system, a reset link is on its way. The link expires in 1 hour.
              </p>
              <button className="init-btn" onClick={onBack} data-testid="forgot-back-after-sent">
                Back to login
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
